import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ReactJson from "@microlink/react-json-view"
import { SearchableUserSelector } from './User';
import moment from 'moment-timezone';
import { useActiveTemplate, useTeamAndUser, useArchives, useTeamAndAllUsers } from '../hook/DataProvider';
import { TimeStringForTimeZone } from "./Setting"
import { toast } from "react-toastify"
import { ReportImage } from './ReportImage';
import { GetUserFullname } from "./User";
import { initFieldMap, isNumberField, toUrlSafeBase64 } from './utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUserCheck, faEnvelope} from "@fortawesome/free-solid-svg-icons"
import { Tooltip } from 'react-tooltip'
import { Bar, BarChart, LabelList, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { ProviderReportChart } from './Chart';
import useAuth from '../hook/useAuth';
import useDeepVinApi from '../hook/useDeepvinApi';
import { ExportCaseReportButton, ExportReportsButton } from './Export';
import { SearchableCaseLabeler } from './Case';
import { GoToLabelsButton } from './Label';
import { ArchiveMoveButton } from './Archive';
import { faUser } from '@fortawesome/free-regular-svg-icons';

export const ReportStatus = {
  InProgress: "reportInprogress",
  Done: "reportDone",
}

export const Reports = () => {
  const { setAuth } = useAuth()
  const api = useDeepVinApi()
  const [reports, setReports] = useState([])
  const [fieldReps, setFieldReps] = useState([]) 
  const [attReps, setAttReps] = useState([]) 
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [flag, setFlag] = useState(false)
  const [teams, users] = useTeamAndUser()
  const [showByProvider, setShowByProvider] = useState(false)

  useEffect(() => {
    api.get("/api/report/", { params: {
      startDate,
      endDate,
    }})
    .then(({data}) => {
      setReports(data)
      let tmpFieldReps = []
      let tmpAttReps = []
      for(const report of data){
        // console.log("report: ", report)
        if (/*report.Attempt === 0*/report.TemplateType === "Field_Report"){
          tmpFieldReps.push(report)
        } else if(/*report.Attempt > 0*/report.TemplateType === "Attempt_Report"){
          tmpAttReps.push(report)
        }
      }
      
      setFieldReps(tmpFieldReps)
      setAttReps(tmpAttReps)
    })
    .catch(error => console.error("API error: ", error))
  }, [flag])

  const handleDateChange = (setter) => (event) => {
    setter(event.target.value)
  }
  const applyTimeFilter = (start, end) => {
    setFlag(!flag)
  }
  const clearTimeFilter = () =>{
    setStartDate('')
    setEndDate('')
    setFlag(!flag)
  }

  return (
    <>
    {/* <ReactJson src={fieldReps} collapsed={3} /> */}
    <div>
      <div class="row mb-3">
        <div class='col-5'>
          <label class="fw-bold">
            Videos From:&nbsp;
            <input class="me-3" type="date" value={startDate} onChange={handleDateChange(setStartDate)} />
          </label>
          <label  class="fw-bold">
            To:&nbsp;
            <input class="me-3" type="date" value={endDate} onChange={handleDateChange(setEndDate)} />
          </label>
          <div class="btn-group" role="group">
              <button class="btn btn-sm btn-success py-0" type="button" onClick={applyTimeFilter}>Apply</button>
              <button class="btn btn-sm btn-warning py-0" type="button" onClick={clearTimeFilter}>Clear</button>
          </div>
        </div>
        <div class="col-3 form-check text-start">
              <input class="form-check-input" type="checkbox" id="flexCheckshowbyprovider" value={showByProvider} onChange={()=>setShowByProvider(!showByProvider)} />
              <label class="form-check-label me-2" for="flexCheckshowbyprovider">
                Show plots by provider
              </label>
        </div>
      </div>
      <ul class="nav nav-tabs" id="reportsTabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active internal-tab" id="field-reports-tab" data-bs-toggle="tab" data-bs-target="#fieldreports" type="button" 
          role="tab" aria-controls="fieldreports" aria-selected="false">Case Reports</button>
        </li>
        { /*(data.IsAdmin || data.IsRoot) &&*/ <li class="nav-item" role="presentation">
          <button class="nav-link internal-tab" id="att-reports-tab" data-bs-toggle="tab" data-bs-target="#attreports" type="button" 
          role="tab" aria-controls="attreports" aria-selected="false">Attempt Reports</button>
        </li>}

      </ul>
      <div class="tab-content" id="reportsContents">
        <div class="tab-pane fade show active" id="fieldreports" role="tabpanel" aria-labelledby="field-reports-tab">
          <ExportReportsButton startDate={startDate} endDate={endDate} templateType={"Field_Report"} />
          <ReportPage tname="ReportTemplate" data={fieldReps} users={users} showByProvider={showByProvider}/>
        </div>
        <div class="tab-pane fade" id="attreports" role="tabpanel" aria-labelledby="att-reports-tab">
          <ExportReportsButton startDate={startDate} endDate={endDate} templateType={"Attempt_Report"} />
          <ReportPage tname="AttemptTemplate" data={attReps} users={users} showByProvider={showByProvider}/>
        </div>
      </div>
    </div>
    </>
  )
}

export const ReportPage = ({tname, data, users, showByProvider}) =>{
  const template = useActiveTemplate(tname)
  const [fieldUserVals, setFieldUserVals] = useState({})

  useEffect(() => {
    if (!template || !template.Fields || !users ||!showByProvider) return

    let fdUserVals = {}
    for (const field of template.Fields) {
      if (field.FieldType === 'text') continue

      let fvs = field.FieldValues?.split(',')
      let userVals = {}
      for (const report of data) {
        let user = users.find(u=>u.ID === report.ProviderID)
        let uid = user === undefined ? "None" : user.ID

        if (userVals[uid] == undefined) userVals[uid]={}

        if (!isNumberField(field.FieldType)){
          if (!fvs || fvs === undefined || fvs.length == 0) {
            continue
          } else {
            for (const fv of fvs) {
              if (userVals[uid][fv] === undefined) userVals[uid][fv]=0
            }
          }
        } else if (userVals[uid]["val_sum"] === undefined) {
          userVals[uid]["val_sum"] = 0
        }
        
        for (const v of report.FieldValues) {
          if(field.ID === v.FieldID) {
            if (isNumberField(field.FieldType)){ 
              userVals[uid]["val_sum"] += v.Value
              userVals[uid]["count"] = userVals[uid]["count"]===undefined ? 1 : userVals[uid]["count"]+1
            } else { // bool, bool+
              let dvs = v.FieldValueList.split(',')
              if (v.Value > 0 && dvs.length>=v.Value){
                let key = dvs[v.Value-1]
                if (fvs.includes(key)){
                  userVals[uid][key] += 1              
                }
              }
            }
            break        
          }
        }
      }
      fdUserVals[field.ID] = userVals
    }

    setFieldUserVals(fdUserVals)
  }, [data, tname, showByProvider])

  let total = data.length
  const average = (id) => {
    let sum = 0

    data.forEach(report => {
        for (const v of report.FieldValues) {
            // console.log("field value array, v.Value, val ", dvs, v.Value, val)
            if (v.FieldID === id){              
                sum += v.Value
                break
            }        
        }
    })
    // console.log("sum, total ", sum, total)
    return parseFloat(sum/total).toFixed(2)
  }

  const percent = (id, val) => {
    let sum = 0

    data.forEach(report => {
        for (const v of report.FieldValues) {
            // console.log("field value array, v.Value, val ", dvs, v.Value, val)
            if (v.FieldID === id){
              let dvs = v.FieldValueList.split(',')
              if (v.Value > 0 && dvs[v.Value-1]===val){
                sum += 1
                break
              }
            }        
        }
    })
    // console.log("sum, total ", sum, total)
    if (sum > 0) return parseFloat(sum/total*100).toFixed(1)/*+"%"*/
  }

  if (data && template)
  return (
    <>
    {/* <h2>{isAttempt ? "Attempt" : "Field"} Reports</h2> */}
    <table class="table table-hover">
      <thead>
        <th>#</th>
        <th class="text-center"></th>
        <th>Description</th>
        {/* <th>Options</th> */}
        <th class="text-center">% of {total} reports</th>
        {showByProvider && <th class="text-center">By provider</th>}
      </thead>
      <tbody>
        {/* {data && data.map(report => <ReportTab report={report} />)} */}

        {template.Fields?.map(field => 
        <tr>
          <td>{field.Number}</td>
          <td class="text-center">
            <input class="form-check-input" type="checkbox"
              checked={field.Enabled} />
          </td>
          <td>{field.Description}</td>
          {/* <td>{field.FieldValues?.split(',').map((val, id) => <p>{val}: {percent(field.ID, id)}</p>)}</td> */}
          <td width={200} class="text-center">
            {field.FieldType === 'text' ? "N/A" 
             : isNumberField(field.FieldType) ? "average " + average(field.ID) : <ResponsiveContainer width="100%" height={240}>
              <BarChart data={field.FieldValues?.split(',').map((val) => ({cat: percent(field.ID,  val), name: val}))}
                margin={{ top: 20, right: 10, left: 10, bottom: 5 }} maxBarSize={30}>
                <XAxis dataKey="name" />
                <YAxis /*domain={[0, 'auto']}*/ allowDataOverflow={false} hide={true}/> 
                <Bar dataKey="cat" fill='#8884d8' isAnimationActive={false}>
                  <LabelList dataKey="cat" position="top" offset="1"/>
                </Bar>
              </BarChart>
            </ResponsiveContainer>}
          </td>
          {showByProvider && <td width="%100" class="text-center">
            {field.FieldType === 'text' ? "N/A" 
             : <ProviderReportChart field={field} reports={data} userVals={fieldUserVals[field.ID]} users={users}/>}
          </td>}
        </tr>)}

      </tbody>
    </table>
    {/* <ReactJson src={{template, data}} /> */}
    </>
  )
}

export const ReportTab = ({report}) => {
  const { auth } = useAuth()

  if (report && report.FieldValues)
  return (
    <tr>
      <td></td>
      <td>{report.CaseNumber}</td>
      <td>{TimeStringForTimeZone(auth, report.Date)}</td>
      <td>{report.TeamID}</td>
      {report.FieldValues.map(v => <td>{v.Value}</td>)}
    </tr>
  )
}

export const RadioButtonGroup = ({title, name, value, onValueChange, labels=["Yes","No","N/A"], colors=["secondary"]}) => {

  return (
    <div class="row mb-3">
      <label class="fw-bold form-label">{title}</label>
      <div class="btn-group col-12">
        {labels.map((label, i) => 
          <>
            <input type="radio" class="btn-check" name={name} id={`${name}-${i+1}`}
              value={i+1} checked={value === i+1} onChange={onValueChange} />
            <label class={`btn btn-outline-${colors.length === 1 ? colors[0] : colors[i]}`}
              for={`${name}-${i+1}`}>{label}</label>
          </>
        )}
      </div>
    </div>
  )
}

export const RadioButtonGroupForField = ({attempt, field, fvalues, fields, onValueChange, relations}) => {
  const baseName = `att_${attempt}_${field.FieldName}`
  
  let data = fvalues?.find(v => v.FieldID === field.ID)
  // use the original value to figure out the index in the field.FieldValues because it may have
  // changed from the template
  // console.log("field: ", field )
  // console.log("data: ", data)
  let oldV = ""
  let index = -1
  if (field?.FieldValues !== data?.FieldValueList && data?.Value>0) {
    let fvs = field.FieldValues.split(',')
    let dvs = data.FieldValueList.split(',')
    index = fvs.indexOf(dvs[data.Value-1])
    // if old FieldValue is found in new template FieldValues, 
    // let's update the old FieldValueList
    if (index>=0) {
      onValueChange(field.ID, field.Description, field.FieldValues, index+1)
    } else{ // the old value is not in new template FieldValues anymore
      oldV = dvs[data.Value-1]
    }
  } else if (data){ index = data.Value-1}

  let val = index >=0 ? index+1 : 0
  // console.log("oldV val: ", oldV, val)
  const [show, setShow] = useState(true)

  useEffect(() => {
    let ignore = false
    // manage relations
    if (!ignore && relations?.length > 0){
      handleRelations(field, relations, fields, fvalues, onValueChange, null, setShow)
    }
    return () => {
      ignore = true
    }
  }, [field, fvalues])

  if(field && show)
  return (
<>
    <RadioButtonGroupPlus id={field.ID} name={baseName} fromProvider={field.FromProvider} required={field.Required}
                      type={field.FieldType} description={field.Description}
                      vals={field.FieldValues} val={val} oldV={oldV}
                      onValueChange={onValueChange} />
{/* <ReactJson src={{field, data}} collapsed={1} /> */}
</>
)

}

export const RadioButtonGroupPlus = ({id, name, fromProvider, required, type, description, vals, val, oldV, onValueChange}) => {

  const onChange = (e) => {
    let v = parseInt(e.target.value, 10)
    onValueChange(id, description, labels.join(','), v)
  }
  description = required ? "*" + description : description
  let labels, colors = ["secondary"]
  
  switch (type) {
    case 'bool':
      labels = ["Yes","No"]
      colors = ["success", "danger"]
      break      
    case 'bool+':
      labels = ["Yes","No", "N/A"]
      colors = ["success", "danger", "secondary"]
      break
    case 'string':
    case 'int':
    default:
      labels = vals.split(',')
      break
  }

  return (
    <>
    <div class="row mb-3">
    {fromProvider 
    ? <label class="fw-bold form-label"><FontAwesomeIcon icon={faUser} id="icon-provider-input"/>&nbsp;&nbsp;{description}&nbsp;&nbsp;{oldV==="" ? <span /> : <span class="bg-warning">(last saved value: {oldV})</span>}</label>
    : <label class="fw-bold form-label">{description}&nbsp;&nbsp;{oldV==="" ? <span /> : <span class="bg-warning">(last saved value: {oldV})</span>}</label>}
    
      <div class="btn-group col-12">
        {labels.map((label, i) => 
          <>
          <input 
            type="radio" 
            class="btn-check" 
            name={name} 
            id={`${name}-${i+1}`}
            value={i+1}
            checked={val === i+1}
            onChange={onChange} 
          />
          <label class={`btn btn-outline-${colors.length === 1 ? colors[0] : colors[i]}`}
            for={`${name}-${i+1}`}>{label}</label>
          </>
        )}
      </div>
    </div>
    {/* <ReactJson src={{field}} collapsed={1} /> */}
    <Tooltip anchorSelect="#icon-provider-input" place="right">Check with the provider</Tooltip>
    </>
  )
}

const getFieldValue=(fv, fields)=>{
  let vals = fv.FieldValueList?.split(',')
  let field = fields?.find(f=>f.ID === fv.FieldID)
  if (!field) return { fVal: '', fField: null };

  return { fVal: (isNumberField(field.FieldType) || field.FieldType === 'text' ? fv.Value
    : (fv.Value > 0 ? vals[fv.Value-1] : '')), fField: field }
}

const getInputType = (field)=>{
  return isNumberField(field?.FieldType) ? 'number' : (field?.FieldType === 'text' ? 'text' : '')
}

const handleRelations =(field, relations, fields, fvalues, onValueChange, setFdRange, setShow) =>{
  const inputType = getInputType(field)
  const dvs = field.FieldValues?.split(',')
  for (let i = 0; i < relations.length; i++) {
    let relation = relations[i]
    // console.log("relation: ", relation)
    
    if (relation.TargetFieldIDs.includes(field.ID)){
      let triggerFV = fvalues?.find(v=>v.FieldID === relation.TriggerFieldID)
      
      if (!triggerFV) continue

      // let targetFV = fvalues?.find(v=>v.FieldID === field.ID)
      // console.log("triggerFV: ", triggerFV)
      let condMet = false
      const { fVal, fField } = getFieldValue(triggerFV, fields)
      const isNumber = inputType==='number'
      switch (relation.TriggerCondition){
        case "=": 
          condMet = relation.TriggerValue === fVal; break
        case ">=":
          condMet = isNumber && fVal >= relation.TriggerValue; break
        case "<=":
          condMet = isNumber && fVal <= relation.TriggerValue; break
        case "<":
          condMet = isNumber && fVal < relation.TriggerValue; break
        case ">":
          condMet = isNumber && fVal > relation.TriggerValue; break
      }
      // console.log("conditionMet, relation, field, inputType ", condMet, relation, field, inputType)
      if (condMet){
        switch (relation.Action){
          case "setValue":
            onValueChange(field.ID, field.Description, field.FieldValues, 
              inputType === 'number' ? parseFloat(relation.Parameters["value"]) 
              : (inputType==='text' ? relation.Parameters["value"] : dvs?.indexOf(relation.Parameters["value"])+1))
            break
          case "setRange": // only for 'decimal' or 'integer' type target
              if (inputType === 'number' && setFdRange){
                setFdRange({
                  min: parseFloat(relation.Parameters['min']),
                  max: parseFloat(relation.Parameters['max']),
                  unit: relation.Parameters['unit'],
                })
              }
              break
          case "show":
            if (setShow) setShow(true); break
          case "hide":
            if (setShow) setShow(false); break
        }
      } else {
        if (setShow) {
          if (relation.Action === 'hide'){
            setShow(true)
          } if(relation.Action === 'show'){
            setShow(false)
          }
        }
      }
    }
  }
}

export const InputBoxGroupForField = ({attempt, field, fvalues, fields, onValueChange, relations}) => {
  const baseName = `att_${attempt}_${field.FieldName}`
  const inputType = getInputType(field)
  let data = fvalues?.find(v => v.FieldID === field.ID)
  // console.log("fvalues: ", fvalues)
  // console.log("field: ", field)
  // console.log("inputType: ", inputType)
  const [show, setShow] = useState(true)
  const [fdRange, setFdRange] = useState({})
 
  useEffect(() => {
    let ignore = false
    // manage relations
    if (!ignore && relations?.length > 0 && inputType !== ''){
      handleRelations(field, relations, fields, fvalues, onValueChange, setFdRange, setShow)
    }
    return () => {
      ignore = true
    }
  }, [field, fvalues])

  const onInputChange = (e) => {
    onValueChange(field.ID, field.Description, "", 
      inputType === 'number' ? parseFloat(e.target.value) : e.target.value
    )
  }

  const parseMinMaxNumbers = (strMinMax) => {
    if (!strMinMax || strMinMax === "") return

    let vals = strMinMax.split(':')
    if (vals.length === 2) {
      if (vals[0] === 'min') {
        fMin = parseFloat(vals[1])
      } else if (vals[0] === 'max') {
        fMax = parseFloat(vals[1])
      }
    }
  }

  let minmaxVals = field.FieldValues?.split(',') // in the format of "min:1,max:10" or "min:1" or "max:10" or ""
  let fMin=NaN, fMax=NaN
  if (inputType === 'number'){
    if (minmaxVals?.length === 2){
       minmaxVals.map(v => parseMinMaxNumbers(v))
    } else if (minmaxVals?.length === 1){
      parseMinMaxNumbers(minmaxVals[0])
    }
  }

  let hasRange = inputType === 'number' && Object.keys(fdRange).length>0
  // combine the range from field value and relations
  if (!isNaN(fMin) && (fdRange.min === undefined || isNaN(fdRange.min) || fMin > fdRange.min)) {
    fdRange.min = fMin
    hasRange = true
  }
  if (!isNaN(fMax) && (fdRange.max === undefined || isNaN(fdRange.max) || fMax < fdRange.max)) {
    fdRange.max = fMax
    hasRange = true
  }

  let desciption = field.Required ? "*" + field.Description : field.Description
  // const propRange = hasRange ? { min: fdRange.min, max: fdRange.max } : {}
  const minRange = hasRange && !isNaN(fdRange.min) ? `min: ${fdRange.min}` : ""
  const maxRange = hasRange && !isNaN(fdRange.max) ? `max: ${fdRange.max}` : ""
  const strRange = minRange + (minRange!== ""&&maxRange!=="" ? ", " + maxRange : maxRange)
  const fieldLabel = hasRange && strRange !=="" ? desciption +" (" + 
    strRange+ (fdRange.unit === undefined ? ")" : " "+fdRange.unit+")") : desciption

  const handleBlur = (event) => {
    let value = parseFloat(event.target.value);
  
    if (hasRange) {
      if (!isNaN(fdRange.min) && value < fdRange.min) {
        value = fdRange.min;
        alert(`Input value is out of range: ` + fieldLabel)
      }
      if (!isNaN(fdRange.max) && value > fdRange.max) {
        value = fdRange.max;
        alert(`Input value is out of range: ` + fieldLabel)
      }
    }
  
    // Update input field with corrected value
    event.target.value = value;
  };

  if(field && inputType !== '' && show)
  return (
    <>
    <div class="row mb-3">
      {field.FromProvider 
      ? <label class="fw-bold form-label"><FontAwesomeIcon icon={faUser} id="icon-provider-input"/>&nbsp;&nbsp;{fieldLabel}</label>
      : <label class="fw-bold form-label">{fieldLabel}</label>}
      
      <div class="input-group col-12">
        <input type={inputType} id={baseName} class="col-sm-2 form-control form-control-sm mb-1"
        /*placeholder={strRange}*/ value={data?.Value} onChange={onInputChange}
        onBlur={hasRange ? handleBlur : undefined} // ✅ Validate only when input loses focus
        onWheel={inputType === 'number' ? (e) => e.target.blur() : undefined} // prevent scroll from changing the value
        min={hasRange && !isNaN(fdRange.min) ? fdRange.min : undefined}
        max={hasRange && !isNaN(fdRange.max) ? fdRange.max : undefined}
        />{/*hasRange && fdRange.unit && <span>&nbsp;{fdRange.unit}</span>*/}
      </div>
    </div>
    {/* <ReactJson src={{field}} collapsed={1} /> */}
    <Tooltip anchorSelect="#icon-provider-input" place="right">Check with the provider</Tooltip>
    </>
  )
}

export const CaseReport = ({caseNumber, archiveID, type, attempt, onSaved, update, status, setStatus}) => {
  const { auth, setAuth } = useAuth()
  const api = useDeepVinApi()
  const [teams, users] = useTeamAndUser()
  const [allteams, allusers] = useTeamAndAllUsers()
 
  const [data, setData] = useState({})
  const [flag, setFlag] = useState(false)
  const refresh = () => setFlag(!flag)
  const reportImageRef = useRef(null)

  const [template, setTemplate] = useState(null)

  //const [templateName, setTemplateName] = useState(type==='Field_Report' ? "ReportTemplate" : "AttemptTemplate")
  const templateTypeId = type==='Field_Report' ? 1 : (type==='Attempt_Report' ? 3 : 0)

  useEffect(() => {

    if (templateTypeId === 0) return

    api.get(`/api/template/${templateTypeId}/relation`)
    .then(({data}) => {
      // returned data includes Fields and Relations
      // type TemplateWithRelations struct {
      //   TemplateWithFields
      //   Relations []FieldRelation
      // }
      setTemplate(data)
      // setTemplate(data.find(t => t.Name === templateName))
    })
    .catch(error => console.error("API error: ", error))
  }, [templateTypeId])

  const encodedCN = toUrlSafeBase64(caseNumber)
  const [reports, setReports] = useState([])
  useEffect(() => {
    if (attempt !== 0) return
    api.get(`/api/report/${encodedCN}`)
    .then(({data}) => setReports(data ? data : []))
    .catch(error => console.error("Error: ", error))
  }, [caseNumber, update])

  // console.log("template fields: ", template?.Fields)
  const reportUrl = `/api/report/${encodedCN}/att/${attempt}`
  const baseLabel = `att_${attempt}`

  const hideProviderSettings = () =>{
    if (auth?.PubAcctSettings){
      let proSetting = auth.PubAcctSettings.find(acs=>acs.FieldName === "SkipProvidersInMainReport")
      // console.log("provider setting: ", auth.PubAcctSettings)
      if (proSetting?.Value) return proSetting.Value === 1
    }
    return false
  }

  const hideProvidersFromMain = hideProviderSettings()

  useEffect(() => {
    api.get(reportUrl)
    .then(({data}) => setData(data))
    .catch(error => console.error("Error: ", error))
  }, [caseNumber, update, flag])

  const onValueChange = (id, desciption, variables, value) => {
    // console.log("###data: ", data)
    let vs = [...data?.FieldValues] // DON'T point to (ie vs = data.FieldValues), MAKE A COPY!!!
    // console.log("###relation value: ", value)
    // console.log("###field values copy: ", vs)
    let index = vs.findIndex(v => v.FieldID === id)
    if (index === -1) vs.push({FieldID: id, FieldDescription: desciption, FieldValueList: variables, Value: value}) // new data
    else if (vs[index].Value !== value){
      vs[index].FieldDescription = desciption
      vs[index].FieldValueList = variables
      vs[index].Value = value
    } else {
      return
    }
    // console.log("vs: ", vs)
    setData({...data, FieldValues: vs})
  } 

  const [caseLabels, setCaseLabels] = useState([])
  const [newLabels, setNewLabels] = useState([])
  useEffect(() => {
      api.get('/api/label/')
      .then(({data}) => setCaseLabels(data))
      .catch(error => console.error("Error fetching case labels: ", error));
  }, [caseNumber])

  const fieldNameMap = initFieldMap(template?.Fields)

  const onCommentsChange = (e) => {
    setData({...data, ["Summary"]: e.target.value})
  }

  // TODO: double check and rewrite!!!
  const onSave = (e) => {
    try {
      api.post(reportUrl, JSON.stringify({
        ...data,
        TemplateID: template.ID,
        TemplateType: template.Type,
        UserType: template.UserType,
        CaseNumber: caseNumber,
      }))
      .then(({data}) => {
        setData(data)
        onSaved(type, attempt)
        toast.success("Report is saved!")
      })

      if (type==='Field_Report'){
        reportImageRef?.current?.saveImageChange()
      }

      // if this is case report and user can assign labels, also save the case labels
      if (attempt === 0 && (auth?.IsRoot || auth?.AssignLabel)){
        api.post(`/api/case/${encodedCN}/label`, { Labels: newLabels })
        .then(({data}) => {
          //console.log("case labels posted: ", newLabels)
          //console.log("case labels saved: ", data)
        })
      }

    }catch(error) {
      if (error.response?.status === 401) {
        setAuth({})
      } else {console.error("Error: ", error)}
    }
  }

  // reviewers
  const [reviewerIDs, setReviewerIDs] = useState([])
  useEffect(() => {
    api.get(`/api/case/${encodedCN}/reviewer`)
    .then(({data}) => setReviewerIDs(data))
    .catch(error => console.error("Error: ", error))
  }, [caseNumber])

  const onConfirmReviewed = () => {
    if (wasReviewed(auth.ID)) return

    api.post(`/api/case/${encodedCN}/reviewer`, {Username: auth.username})
    .then(({data}) => {
      setReviewerIDs(data)
    })
    .catch(error => console.error("Error: ", error))
  }
  
  const wasReviewed = (uid) => {
    return reviewerIDs && reviewerIDs.length > 0 ? reviewerIDs.includes(uid) : false
  }

  const handleNotifyProviders = () => {
    const allproviders = [
      ...new Set(
        reports.flatMap(r => {
          const ids = [];

          if (r.ProviderID != null && r.ProviderID !== 0) {
            ids.push(r.ProviderID);
          }

          if (Array.isArray(r.CoProviderIDs) && r.CoProviderIDs.length > 0) {
            ids.push(...r.CoProviderIDs);
          }

          return ids;
        })
      )
    ];

    if (allproviders.length === 0) {
      alert("No providers have been assigned for this case.");
      return;
    }

    api.post(`/api/task/notify`, {
      Cases: new Array(1).fill(caseNumber),
      UserIDs: allproviders,
      EmailBody: '',
      DueDate: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000) // due in one week,
      })
      .then(({}) => {
        toast.success("Notifications sent successfully")
      })
      .catch((error) => {
        const errMsg =
          typeof error.response?.data?.error === "string"
            ? error.response.data.error
            : JSON.stringify(error.response?.data?.error, null, 2)

        toast.error(
          <div style={{ whiteSpace: "pre-line" }}>
              {"Failed to send notifications to providers. Please make sure the providers' email addresses are valid!\n\n" +
              "Here is the error message:\n" + errMsg}
            </div>,
            { autoClose: false }
        )
        //toast.error(error.response?.data?.error)
      })
  }

  const isRequiredValueMissing = (fieldId, fieldValue, fields) => {
    let field = template?.Fields.find(f => f.ID === fieldId)
    //console.log("fields, fieldId: ", fields, fieldId)
    //console.log("checking required field: ", field, fieldValue)
    if (field){
      if (fieldValue === undefined || fieldValue === null) return true
      if (field.FieldType === 'text'){
        return fieldValue.trim() === ""
      } else if (isNumberField(field.FieldType)){
        return isNaN(fieldValue)
      } else { // bool, bool+
        return fieldValue === 0
      }
    }
    return false
  }

  const toggleDone = (e) => {
    // check whether all required fields are filled in
    if (data.Status !== ReportStatus.Done && template?.Fields){
      let reqFields = template.Fields.filter(f=>f.Enabled && f.Required).map(f=>f.ID)
      let filledFields = data.FieldValues?.filter(v=> reqFields.includes(v.FieldID) && !isRequiredValueMissing(v.FieldID, v.Value)).map(v=>v.FieldID)
      let missingFields = reqFields.filter(rf=>!filledFields?.includes(rf))
      if (missingFields.length > 0){
        let missingNames = template.Fields.filter(f => missingFields.includes(f.ID)).map(mf => mf.FieldName)
        if(!window.confirm("The following required fields are missing values: \n" + missingNames.join(', ') + "\n\nDo you want to continue?")){
          return
        }
      }
    }

    // toggle the status
    let newStatus = data.Status !== ReportStatus.Done ? ReportStatus.Done : ReportStatus.InProgress
    api.post(`/api/report/${encodedCN}/status`, {Status : newStatus})
    .then(({}) => {
      setData({...data, ["Status"]: newStatus})
      setStatus(newStatus)
    })
    .catch(error => console.error("Error: ", error))
  }
  const enabledSortedRels = template?.Relations?.filter(r=>r.Enabled).sort((a,b)=>a.Number-b.Number)
  const enabledFields = template?.Fields?.filter(f=>f.Enabled)
  if (template && data)
  return (    
    <>
    <div class="card" id={`att_${attempt}-rep-card`}>
      {/* <h4 class="card-header text-center">Intubation Report</h4> */}

      <div class="card-body">
        {/* <h5 class="card-title text-center">{attempt===0 && <FontAwesomeIcon icon={faFlag} 
            color={getFlagColor()}/>}&nbsp;&nbsp;Case # {caseNumber}</h5> */}
        {data.UserID ? <p class="card-text">Last modified: {moment(data.UpdatedAt).fromNow()}</p> : ""}
      
        {/*##### when this is attempt report, or case report but there is no saved attempt reports yet #####*/}
        {(attempt > 0 || (attempt ===0 && !hideProvidersFromMain && reports.length < 2)) && <div class="row mb-3">
          <div class="col-6 mb-3">
            <label class="fw-bold form-label">Provider</label>
            <SearchableUserSelector users={users} data={data} setData={setData} />
          </div>      
          <div class="col-6 mb-3">
            <label class="fw-bold form-label">Co-Providers</label>
            {/* <TeamSelector teams={teams} data={data} setData={setData} /> */}
            <SearchableUserSelector users={users} data={data} setData={setData} multi={true}/>
          </div>
        </div>}
        {/*##### when there is case report and there are attempt report(s) #####*/}
        {type==='Field_Report' && !hideProvidersFromMain && reports.length > 1 && 
        reports.sort((a, b) => a.Attempt - b.Attempt).map(rep => rep.Attempt>0 &&
          <div class="row mb-3">      
            <div class="col-6 mb-3">
              <label class="fw-bold form-label">Attempt {rep.Attempt} Provider</label>
              <ul>
                  <li>{GetUserFullname(rep.ProviderID, users)}</li>
              </ul>      
            </div>      
            <div class="col-6 mb-3">
              <label class="fw-bold form-label">Attempt {rep.Attempt} Co-Providers</label>
              <ul>
                {rep.CoProviderIDs?.map(copid => (
                    <li>{GetUserFullname(copid, users)}</li>
                ))}
              </ul>
            </div>
          </div>
        )}
        {attempt ===0  && <div class="row mb-3">
          <div class="col-6 mb-3">
            <GoToLabelsButton />&nbsp;<label class="fw-bold form-label">Case Labels</label><br/>
            <SearchableCaseLabeler labels={caseLabels} casenum={caseNumber} readOnly={!(auth.IsRoot || auth.AssignLabel)} setCaseLabels={setNewLabels}/>
          </div>      
        </div>}
        {/* <ReactJson src={{data}} collapsed="3" /> */}
      </div>

      <h5 class="card-title text-center mb-3">QA Measurements</h5>
      
      <div class="card-body" id={`${baseLabel}-rep-body`}>
        {enabledFields?.map(field => (isNumberField(field.FieldType) || field.FieldType === 'text')
         ? <InputBoxGroupForField attempt={attempt} field={field} fvalues={data.FieldValues} fields={enabledFields}
            onValueChange={onValueChange} relations={enabledSortedRels}/>
         : <RadioButtonGroupForField attempt={attempt} field={field} fvalues={data.FieldValues} fields={enabledFields}
            onValueChange={onValueChange} relations={enabledSortedRels}/>)
        }

        <div class="form-floating">
          <textarea 
            name='review'
            id={`${baseLabel}_summary`}
            class="form-control" 
            style={{ height: '200px' }} 
            value={data.Summary} 
            onChange={onCommentsChange} 
            placeholder="Video Review"
          />
          <label for={`${baseLabel}_summary`}>Comments</label>
        </div>
      </div>
      
      {data && data.CaseNumber && type==='Field_Report' && <ReportImage caseNum={data.CaseNumber} ref={reportImageRef} refresh={refresh}/>}
      <div class="mb-3">
        <label class="fw-bold form-label mx-2">Reviewed by: {reviewerIDs?.length > 0 ? 
          reviewerIDs.map(rid => GetUserFullname(rid, allusers)).join(", ") : "(No marked reviewers)"}</label>
      </div>
      <div class="d-grid gap-1 mx-auto card-body">
        <div class="btn-group" role="group">
          <button onClick={onSave} type="submit" class="btn btn-primary me-3" 
            disabled={!auth.ReportEdit || status===ReportStatus.Done}>Save</button>
          {attempt===0 && <button onClick={toggleDone} type="submit" class="btn btn-outline-primary me-3" 
            disabled={!auth.ReportEdit || reports.length===0}>
              {data.Status===ReportStatus.Done ? "Mark Undone" : "Mark Done"}
            </button>}
          {attempt===0 && <button onClick={onConfirmReviewed} type="submit" class="btn btn-outline-primary me-3" id="btn-mark-reviewed"
            disabled={!auth.ReportEdit /*|| wasReviewed(auth.ID)*/}><FontAwesomeIcon icon={faUserCheck} /></button>}
          {attempt===0 && <button onClick={handleNotifyProviders} type="submit" class="btn btn-outline-primary me-3" id="btn-notify-provider"
            disabled={!auth.IsRoot /*|| reviewerIDs == null || reviewerIDs.length === 0*/}><FontAwesomeIcon icon={faEnvelope} /></button>}
          {attempt===0 && auth.IsRoot && 
            <ExportCaseReportButton caseNum={caseNumber} id="case-export-button" class="btn btn-outline-primary me-3"/>}
          {attempt===0 && auth.IsRoot && auth.ReportEdit && <ArchiveMoveButton arcId={archiveID} caseNum={caseNumber} />}
        </div>
      </div>
      <Tooltip anchorSelect="#btn-mark-reviewed" place="top">Mark Reviewed</Tooltip>
      <Tooltip anchorSelect="#btn-notify-provider" place="top">Notify Providers</Tooltip>
      <Tooltip anchorSelect="#case-export-button" place="top">Export Report as PDF<br />Use png/jpeg for agency logo,<br />svg not supported for export</Tooltip>

      {/* <div class="card-footer text-muted">
        Report has been locked. Submit new comments as Note below.
      </div> */}
    </div>
    {/* <ReactJson src={{data}} collapsed="3" /> */}
    </>
  )
}

export const TemplateSelector = ({id, teams, data, setData, options, onSelect}) => {

  const handleSelect = (e) => {
    onSelect(parseInt(e.target.value))
  }

  const [selectedOption, setSelectedOption] = useState(options[0])

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);
    onSelect(selectedValue); // Call the callback function with the selected value
  };

  return (
    <div>
      <label class="form-label fw-bold me-3">Select Template:</label>
      <select value={id} onChange={handleSelect}>
        <option selected>Pick a template</option>
        {options.map((option, index) => (
          <option key={index} value={option.ID}>
            {option.Name}
          </option>
        ))}
      </select>
    </div>
  );
}

export const ReviewTypeSelector = ({ options, onSelect }) => {
  const [selectedOption, setSelectedOption] = useState(options[0]); // Initialize with the first option

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);
    onSelect(selectedValue); // Call the callback function with the selected value
  };

  return (
    <div>
      <label class="form-label fw-bold me-3">Select Case or Video:</label>
      <select value={selectedOption} onChange={handleSelectChange}>
        {options.map((option, index) => (
          <option key={index} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  );
}
